import { Badge } from 'reactstrap';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { pluralize } from '@s20/common/util/l10n';
import { Dot } from '@s20/components/common/Dot';
import { AccordionCollapse } from '../AccordionCollapse';
import './History.scss';

const actionColors = {
    Created: 'info',
    Modified: 'warning',
    Deleted: 'danger',
};

const HistoryAccordion = ({
    action = 'Modified',
    changeCount,
    children,
    title,
    userDisplayName,
    userName,
}) => (
    <AccordionCollapse
        defaultOpen={false}
        className="mb-2 border-0 bg-light"
        closedIcon={faChevronRight}
        openIcon={faChevronDown}
        title={(
            <span className="d-inline-block align-top text-start">
                <span className="d-block fw-bold text-break">
                    {title}
                </span>
                <span className="d-flex align-items-start mt-1 small text-muted">
                    <Dot
                        color={actionColors[action]}
                        className="flex-shrink-0 mt-1 me-2"
                        aria-hidden="true"
                    />
                    <span className="d-block w-100 overflow-hidden">
                        <span className="d-block text-break">
                            {`${action} by ${userDisplayName}`}
                        </span>
                        {userName && (
                            <span className="d-block text-break opacity-75">
                                {userName}
                            </span>
                        )}
                    </span>
                </span>
            </span>
        )}
        secondaryAction={(
            <Badge
                pill
                color="secondary"
                className="px-2 py-1"
            >
                {pluralize(changeCount, 'change')}
            </Badge>
        )}
    >
        {children}
    </AccordionCollapse>
);

export default HistoryAccordion;
